import classNames from './ChangeLevelPopup.module.scss';
import { TFunction } from 'i18next';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';

export interface StudentsTableData {
  name: string;
  classAndGrade: string;
  currentLevel: string;
}

export const convertStudentReportItemToStudentsTableData = (
  student: StudentReportItem,
  t: TFunction
) => {
  return {
    name: student.name,
    classAndGrade: `${student.groupName} | ${t(`grade_${student.gradeId}`)} ${t('grade')}`,
    currentLevel: student.currentLevel ? t(`levelName_${student.currentLevel}`) : '',
  } as StudentsTableData;
};

interface StudentsTableProps {
  students: StudentsTableData[];
}

const StudentsTable = ({ students }: StudentsTableProps) => {
  const { t } = useAdminTranslation();

  return (
    <div className={classNames.table}>
      <div className={classNames.tableHeader}>
        <div>{t('bulkActions.common.name')}</div>
        <div>{t('bulkActions.common.classAndGrade')}</div>
        <div>{t('bulkActions.changeLevel.currentLevel')}</div>
      </div>
      <div className={classNames.tableBody}>
        {(students || []).map((s, i) => (
          <div key={`StudentsTable-row--${i}`} className={classNames.tableRow}>
            <div>{s.name}</div>
            <div>{s.classAndGrade}</div>
            <div>{s.currentLevel}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentsTable;
